import type { Context, Entity } from '../../types';
import type { AuthorizationScope } from './types';
export const learningManagers = [
  'groupOperator',
  'campusManager',
  'regionManager',
  'researchLead',
];
export const knowledgeReviewers = [
  'groupOperator',
  'campusManager',
  'researchLead',
];
export const sameCampus = (row: Pick<Entity, 'campus'>, context: Context) =>
  context.campus === '全部校区' || row.campus === context.campus;
export function scopeAllows(scope: AuthorizationScope, context: Context) {
  const campus =
    scope.campuses.includes('*') ||
    (context.campus === '全部校区'
      ? scope.campuses.length > 0
      : scope.campuses.includes(context.campus));
  return (
    campus &&
    (!scope.roles.length || scope.roles.includes(context.role)) &&
    (!scope.memberUuids.length ||
      scope.memberUuids.includes(context.viewMemberUuid))
  );
}
/** Minimal shared visibility adapter; audio rights remain governed by the recording domain. */
export function learningAccessOverride(
  row: Entity,
  context: Context,
): boolean | undefined {
  if (row.fields?.softDeleted === 'true') return false;
  if (row.kind === 'knowledge' && row.fields?.learningManaged === 'true') {
    if (
      sameCampus(row, context) &&
      (row.fields.authorView === context.viewMemberUuid ||
        knowledgeReviewers.includes(context.role))
    )
      return true;
    try {
      if (
        row.status !== 'published' &&
        !(
          row.status === 'withdrawn' &&
          JSON.parse(row.fields.historicalMemberUuids || '[]').includes(
            context.viewMemberUuid,
          )
        )
      )
        return false;
      return scopeAllows(
        JSON.parse(row.fields.publishedScope || '{}'),
        context,
      );
    } catch {
      return false;
    }
  }
  if (context.role === 'teacher' && sameCampus(row, context)) {
    if (row.kind === 'plan' && row.fields?.learningManaged === 'true')
      return (
        row.memberUuid === context.viewMemberUuid ||
        row.owner === context.viewMemberUuid
      );
    if (row.kind === 'teacher' && row.fields?.learningProfile) {
      try {
        return (
          row.memberUuid === context.viewMemberUuid ||
          JSON.parse(row.fields.learningProfile).mentorMemberUuid ===
            context.viewMemberUuid
        );
      } catch {
        return false;
      }
    }
  }
  return undefined;
}
export function canManageLearning(row: Entity, context: Context) {
  return (
    sameCampus(row, context) &&
    (learningManagers.includes(context.role) ||
      row.memberUuid === context.viewMemberUuid)
  );
}
